import holidayService from '../../service/holidayService';

const DEST_API_V2 = '/city/destination/v2';
const DEST_API_V1 = '/city/destination';

export const getDestinations = async (params = {}, destV2 = false) =>
  await holidayService.post(destV2 ? DEST_API_V2 : DEST_API_V1, params);
